import { render, staticRenderFns } from "./TiptapToolbarPageLink.vue?vue&type=template&id=7590fc78"
import script from "./TiptapToolbarPageLink.vue?vue&type=script&setup=true&lang=js"
export * from "./TiptapToolbarPageLink.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports